//import axios from 'axios';
import clienteHttp from './ClienteHttps';
//const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

//axios.defaults.withCredentials = true;

class MedicoService {
    async obtenerPerfilMedico(idMedico) {
    try {
      const response = await clienteHttp.get(`/medicos/${idMedico}`);
      return response.data;
    } catch (error) {
      const mensaje = error.response?.data?.mensaje || error.response?.data?.error || 'Error al obtener perfil del médico';
      throw new Error(mensaje);
    }
  }

    async agregarDisponibilidad(idMedico, datosDisponibilidad) {
        try {
            const bodySanitizado = {
                especialidad: datosDisponibilidad.especialidad || null,
                practica: datosDisponibilidad.practica || null,
                diaSemana: datosDisponibilidad.diaSemana.toUpperCase(), 
                horaDesde: datosDisponibilidad.horaDesde,
                horaHasta: datosDisponibilidad.horaHasta,
                sede: datosDisponibilidad.sede
            };

            const response = await clienteHttp.post(`/medicos/${idMedico}/disponibilidades`, bodySanitizado);
            return response.data;
        } catch (error) {
            const mensaje = error.response?.data?.error || error.response?.data?.mensaje || 'Error al agregar la disponibilidad horaria';
            throw new Error(mensaje);
        }
    }

    async eliminarDisponibilidad(idMedico, diaSemana, horaDesde) {
        try {
            const response = await clienteHttp.delete(`/medicos/${idMedico}/disponibilidades`, {
                params: { 
                    diaSemana: diaSemana.toUpperCase(), 
                    horaDesde 
                }
            });
            return response.data;
        } catch (error) {
            const mensaje = error.response?.data?.error || error.response?.data?.mensaje || 'Error al eliminar la disponibilidad';
            throw new Error(mensaje);
        }
    }

    async agregarSede(idMedico, sedeData) {
        try {
            const response = await clienteHttp.post(`/medicos/${idMedico}/sedes`, {
                nombre: sedeData.nombre.trim(),
                direccion: sedeData.direccion.trim()
            });
            return response.data;
        } catch (error) {
            const mensaje = error.response?.data?.error || error.response?.data?.mensaje || 'Error al agregar la sede';
            throw new Error(mensaje);
        }
    }

    async eliminarSede(idMedico, sedeNombre) {
        try {
            const response = await clienteHttp.delete(`/medicos/${idMedico}/sedes/${encodeURIComponent(sedeNombre)}`);
            return response.data;
        } catch (error) {
            const mensaje = error.response?.data?.error || error.response?.data?.mensaje || 'Error al eliminar la sede';
            throw new Error(mensaje);
        }
    }

    async agregarServicio(idMedico, tipoServicio, idServicio, duracionEnMinutos, costo) {
        try {
            const response = await clienteHttp.post(`/medicos/${idMedico}/servicios`, {
                tipoServicio: tipoServicio.toUpperCase(),
                idServicio,
                duracionEnMinutos,
                costo
            });
            return response.data;
        } catch (error) {
            const mensaje = error.response?.data?.error || 'Error al vincular el servicio';
            throw new Error(mensaje);
        }
    }

    async eliminarServicio(idMedico, tipoServicio, idServicio) {
        try {
            const response = await clienteHttp.delete(`/medicos/${idMedico}/servicios/${tipoServicio.toUpperCase()}/${idServicio}`);
            return response.data;
        } catch (error) {
            const mensaje = error.response?.data?.error || 'Error al desvincular el servicio';
            throw new Error(mensaje);
        }
    }

    async modificarServicio(idMedico, tipoServicio, idServicioViejo, idServicioNuevo, duracionEnMinutos, costo) {
        try {
            const response = await clienteHttp.put(`/medicos/${idMedico}/servicios/${tipoServicio.toUpperCase()}/${idServicioViejo}`, {
                idServicioNuevo,
                duracionEnMinutos,
                costo
            });
            return response.data;
        } catch (error) {
            const mensaje = error.response?.data?.error || 'Error al modificar el servicio';
            throw new Error(mensaje);
        }
    }

    async obtenerPacientesDelMedico(idMedico) {
        try {
        const response = await clienteHttp.get(
            `/medicos/${idMedico}/pacientes`
        );
        return response.data;
        } catch (error) {
        const mensaje = error.response?.data?.error || 
                        error.response?.data?.mensaje || 
                        'Error al obtener los pacientes del médico';
        throw new Error(mensaje);
        }
    }


}

export default new MedicoService();